import request from '@/router/axios'

const API = '/api/produce/kanban/planned-vehicle-monitor'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchPlannedVehicleMonitor(data = {}) {
  return request({
    url: API,
    method: 'post',
    data
  }).then(unwrap)
}
